import React, { useMemo } from 'react';
import { IntentBehaviorProvider } from 'seagull';
import { useStore } from "../contexts";
import { selectors } from "../store/state-selectors";
export default function SeagullIntentBehaviorProvider(props) {
  const {
    getIntentBehavior,
    children
  } = props;
  const userRole = useStore(selectors.user.role);
  const intentBehavior = useMemo(() => getIntentBehavior(userRole), [userRole, getIntentBehavior]);
  return /*#__PURE__*/React.createElement(IntentBehaviorProvider, {
    value: intentBehavior
  }, children);
}